module.exports = {
  fullLang: 'English',
  shortLang: 'EN',

  'blog.title': 'Blog',
  'blog.back': 'Back to blog',
  'blog.relatedArticlesHeader': 'Related articles',
  'blog.readMore': 'Read Now',
  'blog.postsTagged': 'Posts tagged',
  'blog.allTags': 'All Tags',
  'blog.hideTags': 'Hide Tags',
  'blog.messageOne': 'KEEP UP WITH OUSTER',
  'blog.messageTwo':
    'Sign up for our newsletter to get updates on all of our new blog posts!',
  'blog.messageThree': 'Sign up today!',
  'blog.defaultAuthor': 'Team Ouster',
  'blog.url': '/company/contact/newsletter/',
  'blog.homeUrl': '/blog/',
  'blog.latestBlogPost': 'Latest Blog Post',

  'nav.getADemo': 'Get a demo',
  'nav.support': 'Support',

  'cta.download': 'Download',
  'cta.readMore': 'Read More',
  'cta.mostRecent': 'Most recent',
  'cta.compare': 'Add a sensor',

  'downloads.title': 'Downloads',
  'downloads.seoTitle': 'Ouster Download Center | Ouster',
  'downloads.ogDescription':
    'Download Ouster lidar datasheets, user manuals, firmware, visualizer tools, and other documents',
  'downloads.hardwareVersion': 'hardware version',
  'downloads.firmwareVersion': 'firmware version',

  'form.email': 'Email',

  'sortable.website': 'Visit Website',

  'product.pricing': 'Volume pricing available',

  'productComparison.select': 'Select up to five sensors to compare',
  'productComparison.selectShort': 'Select your sensors',
  'productComparison.selected': 'selected',
  'productComparison.cancel': 'Cancel',
  'productComparison.compare': 'Compare',
  'productComparison.sensorsSelected': 'SENSORS SELECTED',

  'distributor.logo': 'Logo for',
  'distributor.regions': 'Regions Served',
  'distributor.services': 'Services',

  'careers.apply': 'Apply for this position',
  'careers.description': `Ouster is now hiring a {job} in {location}, View job listing details and apply now!`,
  'careers.title': `{job} Job Opportunity in {location} | Ouster`,

  'firmware.download': 'Download ',
  'firmware.copy': 'Copy',
  'firmware.copied': 'Copied.',
  'firmware.note': 'NOTE',
  'firmware.updates': 'UPDATES',
  'firmware.sha256Hash': 'SHA256 HASH',

  'pointcloud.overlayTitle': 'Interact with our Point Cloud',
  'pointcloud.overlayText':
    'Click in to immersively zoom, pan and rorate our digital point cloud.',
  'pointcloud.overlayButton': 'Launch',
}
